<div class="empty-panel"></div>

<div class="side-panel">
    <div class="row">
        <div class="col title">{{ "PurchaseList.PageTitle" | translate }}</div>
    </div>

    <form [formGroup]="searchForm" novalidate class="voffset-20">
        <div class="form-group form-horizontal">
            <div class="form-group form-horizontal voffset20">
                <label class="panel-label">{{
                    "PurchaseList.Member" | translate
                }}</label>
                <app-membership-search-component
                    hznTestId="purchase-list-member-search"
                    (membershipSelected)="onMembershipSelected($event)"
                    [currentMember]="currentMember"
                ></app-membership-search-component>
            </div>

            <hr />

            <div class="row voffset20">
                <div class="col-12">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{
                            "PurchaseList.Number" | translate
                        }}</label>
                        <div
                            class="form-group form-horizontal input-with-clear"
                        >
                            <i
                                class="fa fa-keyboard-o number-icon"
                                aria-hidden="true"
                            >
                            </i>
                            <input
                                placeholder="Type in purchase number"
                                class="form-control"
                                type="text"
                                hznTestId="purchase-list-number"
                                formControlName="purchaseNumber"
                            />
                            @if (showNumberClear()) {
                                <span
                                    class="input-with-clear-img"
                                    hznTestId="purchase-list-number-clear"
                                    (click)="onNumberClear()"
                                    >&#10006;</span
                                >
                            }
                        </div>
                    </div>
                </div>
            </div>

            <hr />

            <div class="row voffset20">
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{
                            "PurchaseList.DateFrom" | translate
                        }}</label>
                        <bcui-date-picker-input2
                            class="date-picker"
                            hznTestId="purchase-list-date-from"
                            formControlName="dateFrom"
                        >
                        </bcui-date-picker-input2>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{
                            "PurchaseList.DateTo" | translate
                        }}</label>
                        <bcui-date-picker-input2
                            class="date-picker"
                            hznTestId="purchase-list-date-to"
                            formControlName="dateTo"
                        >
                        </bcui-date-picker-input2>
                    </div>
                </div>
            </div>

            <hr />

            <div class="row voffset20">
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{
                            "PurchaseList.AmountFrom" | translate
                        }}</label>
                        <app-amount-picker
                            hznTestId="purchase-list-amount-from"
                            name="amountFrom"
                            formControlName="amountFrom"
                        ></app-amount-picker>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{
                            "PurchaseList.AmountTo" | translate
                        }}</label>
                        <app-amount-picker
                            hznTestId="purchase-list-amount-to"
                            name="amountTo"
                            formControlName="amountTo"
                        ></app-amount-picker>
                    </div>
                </div>
            </div>

            <div class="row voffset20">
                <div class="col-12">
                    <div class="form-group form-horizontal voffset20">
                        <label class="panel-label">{{
                            "PurchaseList.CampType" | translate
                        }}</label>
                        <bcu-drop-down-multiselect-cf2
                            hznTestId="purchase-list-camp-type"
                            [options]="campTypeDropdownItems"
                            [shortenWhenAllSelected]="true"
                            [selectAllOption]="true"
                            (changed)="onCampTypeChanged($event)"
                        >
                        </bcu-drop-down-multiselect-cf2>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
